/* eslint-disable
    no-var,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
let Raven
import { SENTRY_KEY, SENTRY_ENVIRONMENT } from 'constants/ResourcesConstants'

if (SENTRY_KEY) {
  const ravenOptions = {
    ignoreErrors: [
      // Network errors
      'TypeError: Network request failed',
      // TOOD: we might want to remove these later, but as of Jan. 30, 2018 they're SUPER noisy
      'ajax error 404',
      'ajax error 403',
      'ajax error 401',
      'ajax error 0',
    ],
    release: DRIFT_BUILD_ID,
    environment: SENTRY_ENVIRONMENT
  }
  Raven = require('raven-js')
  Raven.config(SENTRY_KEY, ravenOptions).install()
}

const captureExceptions = errors =>
  _.each(errors, function(error, errorKey) {
    if (!error) { return }
    // don't mess with NotFoundError from marty.js
    if ((error.name != null) && (error.name === 'Not found')) {
      console.warn(errorKey, error)
      return
    } else {
      return captureException(error)
    }
  })


const captureResponseException = function(res, ravenData = {}) {
  if ((res.status === 403) || (res.status === 401)) { return }
  const error = new Error(JSON.stringify(res.body))
  return captureException(error, { ...ravenData, level: 'error' })
}

const logError = function(error) {
  console.error(error)
  if (error.stack) {
    return console.error(error.stack)
  }
}

const getRavenClient = function() {
  const isEnabled = (__ENV__ === 'PRODUCTION' || __ENV__ === 'MASTER') && window.location.hostname !== 'localhost'
  if (isEnabled) {
    return Raven
  }
}

var captureException = function(error, ravenData) {
  __guard__(getRavenClient(), x => x.captureException(error, ravenData))
  return logError(error)
}

export { captureExceptions, captureException, captureResponseException, getRavenClient }

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/scripts/utils/SentryHelpers.js